/* eslint-disable max-len */
import { memo } from 'react';

interface IFiltersIconProps {
  fill?: string;
}

function FiltersIcon({ fill = '#080808' }: IFiltersIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="20"
      viewBox="0 0 28 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9269 13.904L25.7208 13.904C26.4402 13.904 27.0234 14.4872 27.0234 15.2066C27.0234 15.926 26.4402 16.5092 25.7209 16.5092L22.9269 16.5092C22.3664 18.3924 20.6219 19.7656 18.5566 19.7656C16.4914 19.7656 14.7468 18.3924 14.1864 16.5092L2.27427 16.5092C1.55487 16.5092 0.97168 15.926 0.97168 15.2066C0.97168 14.4872 1.55487 13.904 2.27427 13.904L14.1864 13.904C14.7468 12.0208 16.4914 10.6475 18.5566 10.6475C20.6219 10.6475 22.3664 12.0208 22.9269 13.904ZM16.6028 15.2149L16.6027 15.2106C16.6027 14.7088 16.7909 14.251 17.1006 13.904C17.4583 13.5042 17.9779 13.2527 18.5566 13.2527C19.6357 13.2527 20.5105 14.1275 20.5105 15.2066C20.5105 16.2857 19.6357 17.1604 18.5566 17.1604C17.4803 17.1604 16.6072 16.2902 16.6028 15.2149Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8088 3.48328L25.7209 3.48328C26.4403 3.48328 27.0234 4.06647 27.0234 4.78587C27.0234 5.50527 26.4403 6.08845 25.7209 6.08845L13.8088 6.08845C13.2483 7.97166 11.5038 9.34492 9.4385 9.34492C7.37324 9.34492 5.62871 7.97166 5.06824 6.08845L2.27427 6.08845C1.55487 6.08845 0.971681 5.50526 0.971681 4.78586C0.971681 4.06647 1.55487 3.48328 2.27427 3.48328L5.06824 3.48328C5.62871 1.60007 7.37324 0.226807 9.4385 0.226807C11.5038 0.226807 13.2483 1.60007 13.8088 3.48328ZM10.8949 3.48328C10.5371 3.08355 10.0172 2.83198 9.4385 2.83198C8.35941 2.83198 7.48462 3.70677 7.48462 4.78587C7.48462 5.86496 8.3594 6.73975 9.4385 6.73975C10.0172 6.73975 10.5371 6.48818 10.8949 6.08845L10.8861 6.08845C11.1952 5.74277 11.3832 5.28629 11.3832 4.78587C11.3832 4.28544 11.1952 3.82896 10.8861 3.48328L10.8949 3.48328Z"
        fill={fill}
      />
      <path
        d="M0.97168 15.2066C0.97168 14.4872 1.55487 13.904 2.27427 13.904L0.97168 13.904L0.97168 15.2066Z"
        fill={fill}
      />
      <path
        d="M2.27427 16.5092C1.55487 16.5092 0.97168 15.926 0.97168 15.2066L0.97168 16.5092L2.27427 16.5092Z"
        fill={fill}
      />
      <path
        d="M25.7208 13.904C26.4402 13.904 27.0234 14.4872 27.0234 15.2066L27.0234 13.904L25.7208 13.904Z"
        fill={fill}
      />
      <path
        d="M27.0234 15.2066C27.0234 15.926 26.4402 16.5092 25.7209 16.5092L27.0234 16.5092L27.0234 15.2066Z"
        fill={fill}
      />
      <path
        d="M27.0234 4.78587C27.0234 5.50527 26.4403 6.08845 25.7209 6.08845L27.0234 6.08845L27.0234 4.78587Z"
        fill={fill}
      />
      <path
        d="M25.7209 3.48328C26.4403 3.48328 27.0234 4.06647 27.0234 4.78587L27.0234 3.48328L25.7209 3.48328Z"
        fill={fill}
      />
      <path
        d="M0.971681 4.78586C0.971681 4.06647 1.55487 3.48328 2.27427 3.48328L0.971679 3.48328L0.971681 4.78586Z"
        fill={fill}
      />
      <path
        d="M2.27427 6.08845C1.55487 6.08845 0.971681 5.50526 0.971681 4.78586L0.971681 6.08845L2.27427 6.08845Z"
        fill={fill}
      />
    </svg>
  );
}

export default memo(FiltersIcon);
